import './bootstrap.js';
import { registerVueControllerComponents } from '@symfony/ux-vue';
import { createApp } from 'vue';
import './styles/app.css';
import '@splidejs/splide/dist/css/splide.min.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import { trans } from "./js/utilities/revrs-translations";
import { initPhotoSwipeGallery } from './js/photoswipe-gallery.js';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

const isMobile = window.innerWidth < 768;

AOS.init({
    offset: isMobile ? 50 : 100,
    once: true,
    duration: 800,
    easing: 'ease-out',
    anchorPlacement: 'center-bottom',
    debounceDelay: 50,
    throttleDelay: 99
});


const app = createApp({});

registerVueControllerComponents(require.context('./vue/controllers', true, /\.vue$/));

app.directive("click-outside", {
    beforeMount: function (el, binding) {
        // Define ourClickEventHandler
        const ourClickEventHandler = event => {
            if (!el.contains(event.target) && el !== event.target) {
                binding.value(event);
            }
        };
        el.__vueClickEventHandler__ = ourClickEventHandler;

        document.addEventListener("click", ourClickEventHandler);
    },
    unmounted: function (el) {
        document.removeEventListener("click", el.__vueClickEventHandler__);
    }
})

app.mount('#app');

const homeFourBanner = document.querySelector("#hero-banner");
const homeFourImag = document.querySelector("#hero-banner .img");
let perspectiveValue = 20; // Initial perspective value
if (homeFourBanner) {
    document.addEventListener("scroll", (e) => {
        const top = window.pageYOffset || document.documentElement.scrollTop;
        if (homeFourImag) {
            if (top > 500) {
                homeFourImag.style.transform = "none";
            } else {
                const calcValue = perspectiveValue + top / 2;
                homeFourImag.style.transform = `perspective(${calcValue}px) rotateX(1deg)`;
            }
        }
    });
}

const initFAQ = () => {
    const faqContainers = document.querySelectorAll('.faq-container');
    if (!faqContainers.length) return;

    // Function to check if we're on mobile
    const isMobile = () => window.innerWidth < 1024;

    const closeItem = (item) => {
        const content = item.querySelector('.faq-content');
        const trigger = item.querySelector('.faq-trigger');
        const icon = trigger?.querySelector('svg');

        content.dataset.open = 'false';

        if (content.style.height === 'auto' || !content.style.height) {
            content.style.height = `${content.scrollHeight}px`;
        }

        // Force a reflow so closing transition runs reliably
        void content.offsetHeight;

        content.style.height = '0';
        content.style.opacity = '0';

        icon?.classList.remove('rotate-180');
        trigger?.classList.remove('bg-secondary-400', 'text-white');
        trigger?.classList.add('text-gray-900');
        trigger?.classList.add('hover:bg-gray-accent');
        trigger?.classList.add('bg-white');
    };

    const openItem = (item) => {
        const content = item.querySelector('.faq-content');
        const trigger = item.querySelector('.faq-trigger');
        const icon = trigger?.querySelector('svg');

        const targetHeight = content.scrollHeight;
        content.style.height = `${targetHeight}px`;
        content.style.opacity = '1';
        content.dataset.open = 'true';

        icon?.classList.add('rotate-180');
        trigger?.classList.add('bg-secondary-400', 'text-white');
        trigger?.classList.remove('text-gray-900');
        trigger?.classList.remove('hover:bg-gray-accent');
        trigger?.classList.remove('bg-white');
    };

    const closeAllItems = () => {
        document.querySelectorAll('.faq-item').forEach(closeItem);
    };

    // Initial state setup
    const setupInitialState = () => {
        closeAllItems();
    };

    // Set up click handlers
    faqContainers.forEach(container => {
        container.querySelectorAll('.faq-content').forEach(content => {
            content.addEventListener('transitionend', (event) => {
                if (event.propertyName !== 'height') return;
                if (content.dataset.open === 'true') {
                    content.style.height = 'auto';
                }
            });
        });

        const triggers = container.querySelectorAll('.faq-trigger');

        triggers.forEach(trigger => {
            trigger.addEventListener('click', function() {
                const item = this.closest('.faq-item');

                // Close all other items, considering mobile/desktop state
                if (isMobile()) {
                    document.querySelectorAll('.faq-item').forEach(otherItem => {
                        if (otherItem !== item) {
                            closeItem(otherItem);
                        }
                    });
                } else {
                    const currentContainer = this.closest('.faq-container');
                    currentContainer.querySelectorAll('.faq-item').forEach(otherItem => {
                        if (otherItem !== item) {
                            closeItem(otherItem);
                        }
                    });
                }

                const isOpen = item.querySelector('.faq-content').dataset.open === 'true';
                if (isOpen) {
                    closeItem(item);
                } else {
                    openItem(item);
                }

                requestAnimationFrame(() => {
                    AOS.refresh();
                });
            });
        });
    });

    // Initial setup
    setupInitialState();

    // Handle resize events - only reset on significant width changes, not mobile scroll
    let resizeTimeout;
    let lastWidth = window.innerWidth;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const currentWidth = window.innerWidth;
            // Only reset if width actually changed (not just height from mobile scrolling)
            if (Math.abs(currentWidth - lastWidth) > 50) {
                setupInitialState();
                lastWidth = currentWidth;
            }
        }, 250);
    });

    // Initial AOS refresh
    AOS.refresh();
};

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', initFAQ);



// --- Google Ads Outbound Click Tracking ---

// Helper function to delay opening a URL until a gtag event is sent.
function gtagSendEvent(url, openInNewTab = false) {
  var callback = function () {
    if (typeof url === 'string') {
      if (openInNewTab) {
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        window.location = url;
      }
    }
  };
  // Ensure gtag function exists before calling
  if (typeof gtag === 'function') {
      gtag('event', 'conversion_event_outbound_click', {
        'event_callback': callback,
        'event_timeout': 2000, // 2 seconds timeout
      });
  } else {
      console.warn('gtag function not found. Google Ads conversion not sent. Navigating directly.');
      // Fallback to direct navigation if gtag is missing
      if (typeof url === 'string') {
          if (openInNewTab) {
            window.open(url, '_blank', 'noopener,noreferrer');
          } else {
            window.location = url;
          }
      }
  }
  return false; // Prevent default link behavior
}

// Function to initialize the click listener
function initOutboundLinkTracking() {
    document.body.addEventListener('click', function(event) {
        // Find the closest ancestor anchor tag
        const link = event.target.closest('a');

        // Check if it's a link and points to app.getrevrs.com
        if (link && link.href && link.href.startsWith('https://app.getrevrs.com/')) {
            // Prevent the default link navigation
            event.preventDefault();
            // Check if link should open in new tab
            const openInNewTab = link.target === '_blank';
            // Call the helper function to send the event and then navigate
            gtagSendEvent(link.href, openInNewTab);
        }
    }, false); // Use capture phase 'false' (bubble phase)
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', initOutboundLinkTracking);

// --- End Google Ads Outbound Click Tracking ---


CookieConsent.run({
    guiOptions: {
        consentModal: {
            layout: "cloud",
            position: "bottom center",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: false
        }
    },
    categories: {
        necessary: {
            readOnly: true
        },
        functionality: {},
        analytics: {}
    },
    disablePageInteraction: true,
    language: {
        default: document.documentElement.lang || 'en',
        translations: {
            [document.documentElement.lang]: {
                consentModal: {
                    title: trans('revrs.cookies.settings'),
                    description: trans('revrs.cookies.description'),
                    acceptAllBtn: trans('revrs.cookies.acceptAll'),
                    // acceptNecessaryBtn: trans('revrs.cookies.rejectAll'), // Removed from initial modal
                    showPreferencesBtn: trans('revrs.cookies.managePreferences'),
                },
                preferencesModal: {
                    title: trans('revrs.cookies.settings'),
                    acceptAllBtn: trans('revrs.cookies.acceptAll'),
                    acceptNecessaryBtn: trans('revrs.cookies.rejectAll'),
                    savePreferencesBtn: trans('revrs.cookies.savePreferences'),
                    closeIconLabel: trans('revrs.cookies.close'),
                    sections: [
                        {
                            title: trans('revrs.cookies.necessary.title'),
                            description: trans('revrs.cookies.necessary.description'),
                            linkedCategory: 'necessary'
                        },
                        {
                            title: trans('revrs.cookies.analytics.title'),
                            description: trans('revrs.cookies.analytics.description'),
                            linkedCategory: 'analytics',
                            cookieTable: {
                                headers: {
                                    name: trans('revrs.cookies.table.service'),
                                    description: trans('revrs.cookies.table.description')
                                },
                                body: [
                                    {
                                        name: trans('revrs.cookies.googleanalytics.name'),
                                        description: trans('revrs.cookies.googleanalytics.description')
                                    },
                                    {
                                        name: trans('revrs.cookies.facebookpixel.name'),
                                        description: trans('revrs.cookies.facebookpixel.description')
                                    }
                                ]
                            }
                        }
                    ]
                }
            }
        }
    }
});

// Smooth scroll to testimonials section
const initSmoothScrollToTestimonials = () => {
    const scrollTriggers = document.querySelectorAll('.scroll-to-testimonials');

    scrollTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            const testimonialsSection = document.getElementById('testimonials');

            if (testimonialsSection) {
                const offset = 80; // Adjust this value based on your header height or desired spacing
                const elementPosition = testimonialsSection.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
};

// Initialize PhotoSwipe for dashboard images on how-it-works page
document.addEventListener('DOMContentLoaded', () => {
    const dashboardGallery = document.querySelector('#dashboard-gallery');
    if (dashboardGallery) {
        initPhotoSwipeGallery('#dashboard-gallery');
    }

    // Initialize PhotoSwipe for mockup images on index page
    const desktopMockupGallery = document.querySelector('#desktop-mockup-gallery');
    const mobileMockupGallery = document.querySelector('#mobile-mockup-gallery');

    if (desktopMockupGallery) {
        initPhotoSwipeGallery('#desktop-mockup-gallery');
    }

    if (mobileMockupGallery) {
        initPhotoSwipeGallery('#mobile-mockup-gallery');
    }

    // Initialize smooth scroll to testimonials
    initSmoothScrollToTestimonials();
    
    // Parallax effect disabled - hero section now scrolls normally
    // If you want to re-enable parallax, uncomment the following code:
    /*
    // Initialize parallax effect for hero sections (index, pricing, contact)
    const parallaxBg = document.querySelector('.parallax-bg');
    const parallaxSlow = document.querySelectorAll('.parallax-slow');
    const parallaxMedium = document.querySelectorAll('.parallax-medium');
    const parallaxFast = document.querySelectorAll('.parallax-fast');
    
    if (parallaxBg) {
        // Hero parallax effects
        function updateParallax() {
            const scrollTop = window.pageYOffset;
            // Determine hero height based on page
            const heroSection = document.querySelector('section[class*="h-screen"], section[class*="h-[30vh]"]');
            const heroHeight = heroSection ? (heroSection.classList.contains('h-screen') ? window.innerHeight : window.innerHeight * 0.3) : window.innerHeight;
            
            // Only apply parallax effect when we're in the hero section
            if (scrollTop < heroHeight) {
                // Parallax background - move slower than scroll to create depth
                const speed = -0.3;
                parallaxBg.style.transform = `translate3d(0, ${scrollTop * speed}px, 0)`;
                
                // Parallax elements with different speeds for depth effect
                parallaxSlow.forEach(el => {
                    const speed = -0.1;
                    el.style.transform = `translate3d(0, ${scrollTop * speed}px, 0)`;
                });
                
                parallaxMedium.forEach(el => {
                    const speed = -0.2; 
                    el.style.transform = `translate3d(0, ${scrollTop * speed}px, 0)`;
                });
                
                parallaxFast.forEach(el => {
                    const speed = -0.25;
                    el.style.transform = `translate3d(0, ${scrollTop * speed}px, 0)`;
                });
            }
        }
        
        // Throttled scroll handler for parallax
        let ticking = false;
        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(() => {
                    updateParallax();
                });
                ticking = true;
                setTimeout(() => { ticking = false; }, 16);
            }
        }
        
        // Update on scroll
        window.addEventListener('scroll', requestTick);
        
        // Initial update
        updateParallax();
    }
    */
});
